export default __webpack_public_path__ + "static/media/Ubuntu-R.c59f3152.woff";